/* eslint-disable */
import { take, put, select } from "redux-saga/effects";
import axios from "axios";
import { currentPageActionTypes } from "../actions/actionTypes";
import * as currentPageActions from "../actions/currentPageActions";
import { getHttpConfig } from "../../Utils/Helpers/common";

const LOAN_PAGE_URL = "loan";
const LOAN_DETAILS_SP = "DF.usp_GetHideandShowFlag";
const LOAN_DETAILS_SP_ID = "loanDetails";

function* getLoanDetails(crmId, config) {
  try {
    const res = yield axios.post(
      `${process.env.API_URL}/SQLQuery/getDataFromMultipleSPs?chartSPs=false`,
      [
        {
          id: LOAN_DETAILS_SP_ID,
          spName: LOAN_DETAILS_SP,
          parameters: { LoanId: crmId },
        },
      ],
      config
    );
    const rows = res?.data?.[LOAN_DETAILS_SP_ID];
    return Array.isArray(rows) ? rows[0] ?? null : rows ?? null;
  } catch (e) {
    console.log(`${LOAN_DETAILS_SP} failed for crmId ${crmId}:`, e);
    return null;
  }
}

export function* getCurrentPageSaga() {
  while (true) {
    const action = yield take(currentPageActionTypes.GET_CURRENT_PAGE);
    const { pageUrl, crmId } = action.payload;
    console.log("getCurrentPageSaga is called:", action.payload);

    const state = yield select();
    let config = getHttpConfig();
    if (
      !config.headers.Authorization ||
      config.headers.Authorization == "Bearer undefined"
    ) {
      const serializedState = sessionStorage.getItem(
        `oidc.user:${process.env.OIDC_AUTHORITY}:MinervaPortal`
      );
      if (serializedState === null) {
        return undefined;
      }
      const appState = JSON.parse(serializedState);
      if (appState && appState.access_token) {
        config.headers.Authorization = "Bearer " + appState.access_token;
      }
    }
    try {
      const res = yield axios.post(
        `${process.env.API_URL}/CRMData/getViewTemplates?pageUrl=${pageUrl}&crmId=${crmId}`,
        null,
        config
      );
      // as of now hardcoded
      let loanDetails = {currentLoanStage: "Initial Enquiry", InterestType: "Hybrid"};
      if (pageUrl === LOAN_PAGE_URL) {
        loanDetails = yield* getLoanDetails(crmId, config);
      }

      yield put(
        currentPageActions.getCurrentPageSucceeded({
          ...res.data,
          ...(loanDetails
            ? { data: { ...res.data?.data, ...loanDetails } }
            : {}),
          getCurrentPageSucceeded: true,
          isLoading: false, // returning loading false when data is available
        })
      );
    } catch (e) {
      yield put(
        currentPageActions.getCurrentPageFailed({
          msg: "Some error occured",
          data: pageUrl,
          getCurrentPageSucceeded: false,
          isLoading: false,
        })
      );
    }
  }
}
